/**
 *
 * @param firstName {string} - First name of user
 * @param lastName {string} - Last name of user
 * @returns {string} - initials of full name
 */
export const getInitialsFromFullName = (
  firstName: string,
  lastName: string
) => {
  if (!firstName || !lastName) return "";

  const fullName = `${firstName.trim() ?? ""} ${lastName.trim() ?? ""}`;

  return `${fullName.split(" ")[0][0]}${fullName.split(" ")[1][0]}`;
};
